import axios from "axios";
import { getStorage } from "../helpers/apihelper";
import { baseURL } from "../config/filepath";
let axiosInstance = axios.create({
  baseURL,
});
axiosInstance.interceptors.request.use(
  function (config) {
    const token = getStorage("token");
    if (token !== null) {
      config.headers["Authorization"] = `Bearer ${atob(token)}`;
    }
    config.headers["lang"] = JSON.parse(localStorage.getItem('lang'))?.code || "en";
    return config;
  },
  function (err) {
    return Promise.reject(err);
  },
);


axiosInstance?.interceptors?.response?.use(
  function (response) {
    return response;
  },
  function (error) {
    if ( error?.response && (error?.response?.status === 403 || error?.response?.status === 401)
    ) {
      
      sessionStorage.clear()
      window.location.href = "/admin/signin";  
    }
    return Promise.reject(error);
  }
);
export default axiosInstance;
